const state = {
  loginUsuario: {
    usuario: Array,
    grupo: Array,
    contrato: Array,
    token: null,
    data_expiracao: String
  }
}

const mutations = {
  setLoginUsuario (state, obj) {
    state.loginUsuario = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/login.js